export default "__VITE_ASSET__BG6O6Nbl__"